import type { SVGProps } from 'react';

export type HubspotIconProps = SVGProps<SVGSVGElement>;

export const HubspotIcon = ({ className, ...props }: HubspotIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#hubspot-clip)">
        <path
          d="M12 23.9993C18.6274 23.9993 24 18.6267 24 11.9993C24 5.37191 18.6274 -0.000671387 12 -0.000671387C5.37258 -0.000671387 0 5.37191 0 11.9993C0 18.6267 5.37258 23.9993 12 23.9993Z"
          fill="#FF7A59"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7175 14.6463C13.7883 14.6463 13.0346 13.9275 13.0346 13.0406C13.0346 12.1538 13.7881 11.4347 14.7175 11.4347C15.6469 11.4347 16.4008 12.1535 16.4008 13.0406C16.4008 13.9277 15.6473 14.6463 14.7175 14.6463ZM15.2215 9.949V8.51932C15.4186 8.43227 15.5859 8.29274 15.7035 8.11715C15.8212 7.94156 15.8844 7.73722 15.8858 7.52815V7.49511C15.8858 6.89089 15.3676 6.39683 14.735 6.39683H14.7002C14.0683 6.39683 13.5494 6.89113 13.5494 7.49511V7.52815C13.5508 7.7372 13.614 7.94153 13.7317 8.11711C13.8494 8.29268 14.0166 8.43222 14.2136 8.51932V9.949C13.6461 10.0316 13.111 10.2561 12.6616 10.6003L8.55171 7.54948C8.58047 7.44912 8.59591 7.34563 8.59764 7.24151C8.59764 6.55691 8.01701 6.00121 7.29979 5.99933C6.58257 5.99746 6.00073 6.55222 6 7.23706C5.99927 7.9219 6.57966 8.47643 7.29688 8.4776C7.52152 8.47667 7.74205 8.4194 7.93681 8.31143L11.9806 11.3138C11.6168 11.8363 11.4267 12.4533 11.4357 13.0827C11.4447 13.712 11.6523 14.3237 12.0309 14.8364L10.8006 16.0106C10.655 15.9666 10.5013 15.9536 10.35 15.9724C10.1987 15.9912 10.0535 16.0414 9.92425 16.1196C9.79502 16.1977 9.6849 16.302 9.60147 16.4251C9.51804 16.5483 9.46329 16.6874 9.44099 16.8329C9.41869 16.9784 9.42937 17.1269 9.47229 17.268C9.51521 17.4092 9.58935 17.5397 9.68961 17.6505C9.78987 17.7614 9.91386 17.85 10.053 17.9102C10.1922 17.9704 10.3433 18.0008 10.4958 17.9993C11.0849 17.9993 11.5628 17.5432 11.5628 16.9809C11.5617 16.8821 11.5453 16.784 11.5142 16.6898L12.7294 15.5292C13.3014 15.9473 13.9997 16.1735 14.7175 16.173C16.5308 16.173 18 14.7708 18 13.0406C18 11.4745 16.794 10.1813 15.2213 9.949"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="hubspot-clip">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
